export const personal_info_ru = {
  title: "",
  description: "",
  fio: {
    label: "",
    no_lastname: "",
    complete_label: "",
    placeholder: "",
    desktop_tooltip: "",
    mobile_tooltip: ""
  },
  firstname: {
    label: "",
    complete_label: "",
    placeholder: "",
    desktop_tooltip: "",
    mobile_tooltip: ""
  },
  lastname: {
    label: "",
    complete_label: "",
    placeholder: "",
    desktop_tooltip: "",
    mobile_tooltip: ""
  },
  secondname: {
    label: "",
    complete_label: "",
    placeholder: "",
    desktop_tooltip: "",
    mobile_tooltip: ""
  },
  iin: {},
  document: {},
  citizenship: {},
  document_number: {},
  date_issue: {},
  date_duration: {},

  step_tooltip: "",
  next_step_button: ""
};
export const personal_info_kz = {
  title: "",
  description: "",
  fio: {
    label: "",
    no_lastname: "",
    complete_label: "",
    placeholder: "",
    desktop_tooltip: "",
    mobile_tooltip: ""
  },
  firstname: {
    label: "",
    complete_label: "",
    placeholder: "",
    desktop_tooltip: "",
    mobile_tooltip: ""
  },
  lastname: {
    label: "",
    complete_label: "",
    placeholder: "",
    desktop_tooltip: "",
    mobile_tooltip: ""
  },
  secondname: {
    label: "",
    complete_label: "",
    placeholder: "",
    desktop_tooltip: "",
    mobile_tooltip: ""
  },
  iin: {},
  document: {},
  citizenship: {},
  document_number: {},
  date_issue: {},
  date_duration: {},

  step_tooltip: "",
  next_step_button: ""
};
